<template>
    <path fill-rule="evenodd" d="M16 28.846c2.308 0 4.462-.59 6.462-1.77 1.948-1.127 3.487-2.666 4.615-4.614 1.18-2 1.77-4.154 1.77-6.462 0-1.462-.232-2.865-.693-4.212-.462-1.346-1.128-2.57-2-3.673L8.115 26.154c1.103.872 2.327 1.538 3.673 2 1.347.461 2.75.692 4.212.692zM3.154 16c0 1.462.23 2.865.692 4.212.462 1.346 1.128 2.57 2 3.673L23.885 5.846c-1.103-.872-2.327-1.538-3.673-2-1.347-.461-2.75-.692-4.212-.692-2.308 0-4.462.59-6.462 1.77C7.59 6.05 6.051 7.59 4.923 9.537c-1.18 2-1.77 4.154-1.77 6.462zM16 0c2.923 0 5.628.73 8.115 2.192 2.41 1.385 4.308 3.282 5.693 5.693C31.269 10.372 32 13.077 32 16s-.73 5.628-2.192 8.115c-1.385 2.41-3.282 4.308-5.693 5.693C21.628 31.269 18.923 32 16 32s-5.628-.73-8.115-2.192c-2.41-1.41-4.308-3.32-5.693-5.731C.731 21.59 0 18.897 0 16c0-2.897.73-5.59 2.192-8.077 1.41-2.41 3.32-4.32 5.731-5.73C10.41.73 13.103 0 16 0z"/>
</template>

<script>
export default {
    name: 'blockIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
